import { ref } from 'vue';
import { EntityTypeQuery } from '@/services/api/resources/entityType/query';
import { useTask } from '@/ui/concerns';
import { list as getEntityTypeList } from '@/services/api/resources/entityType';
import { sequence } from '@/ui/helpers';

export const useEntityTypeCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const entityTypeQuery = (): EntityTypeQuery => ({
    search: '',
    sort: '',
    dir: '',
    page: 1,
    perPage: 1,
  });

  const performCheck = useTask(
    () => sequence(
      getEntityTypeList(entityTypeQuery()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
